module.exports = __webpack_public_path__ + "img/header.ec5bf95.svg";